import { useState, useEffect } from "react";
import { message, Modal } from "antd";
import { DropzoneArea } from 'material-ui-dropzone';
import { useHistory } from 'react-router-dom'

import Layout from "../Layout/Layout";
import Header from "../Components/Header";
import FourCardSection from "../Components/FourCardSection";
import PlanSection from "../Components/PlanSection";
import { url, header } from "../Constent/Constant";
import GetQuoteForm from "../Components/GetQuoteForm";

function LocalDistanceMoving() {
  const [LongDistanceMovingData, setLongDistanceMovingData] = useState('')
  const [HeadingUpdate, setHeadingUpdate] = useState('')
  const [TextModalVisible, setTextModalVisible] = useState(false);
  const [ImageUpdate, setImageUpdate] = useState(null)
  const [ImageModal, setImageModal] = useState(false);
  const [UpdateId, setUpdateId] = useState('')
  const history = useHistory()

  const LoggedIn = localStorage.getItem('MS-Login')
  if(LoggedIn !== 'true'){
    history.push('/')
  }


  useEffect(() => {
    UpdateData()
  }, []);

  const UpdateData = () => {
    fetch(`${url}/page/viewpagedata`, {
      method: 'POST',
      body: JSON.stringify({
        name: "Long Distance Moving"
      }),
      headers: header
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        setLongDistanceMovingData(data.doc)
      })
  }

  const UpdateText = (DataObject) => {
    console.log(DataObject);
    if (DataObject !== "") {
      fetch(`${url}/page/updatedata`, {
        method: "POST",
        body: JSON.stringify({
          id: DataObject.id,
          content: DataObject.text,
        }),
        headers: header,
      })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if (data.message === "Success") {
            UpdateData();
          }
        });
    }
  };

  const UpdateImage = (DataObject) => {
    const Imagedata = new FormData();
    Imagedata.append("image", DataObject.image);
    Imagedata.append("id", DataObject.id);

    fetch(`${url}/page/updateimage`, {
      method: "POST",
      body: Imagedata,
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.message === "Success") {
          UpdateData();
        }
      });
  };

  const handleCancel = () => {
    setTextModalVisible(false);
  };

  const ShowTextModal = (id) => {
    setTextModalVisible(true);
    setUpdateId(id);
  };

  const showImageModal = (id) => {
    setImageModal(true);
    setUpdateId(id)
  };

  const TextHandle = () => {
    if (HeadingUpdate === "") {
      message.error("Fill the Field");
    } else {
      UpdateText({
        text: HeadingUpdate,
        id: UpdateId,
      });
      setTextModalVisible(false);
      setHeadingUpdate("");
    }
  };

  const OnImageHandle = () => {
    if (ImageUpdate === null) {
      message.error('Insert Image')
    } else {
      UpdateImage({
        image: ImageUpdate,
        id: UpdateId
      })
      setImageModal(false);
    }
  };

  const OnEnterPress = (event) => {
    const a = HeadingUpdate;
    console.log(a);
    if (event.key === "Enter") {
      console.log("Enter Clicked");
      a.concat("\n");
      setHeadingUpdate(a);
    } else {
      console.log(event.key);
    }
  };

  return (
    <Layout>
      {LongDistanceMovingData && <Header
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        GetData={{
          imgId: LongDistanceMovingData.section1image1._id,
          headingId: LongDistanceMovingData.section1heading1._id
        }}
        Image={LongDistanceMovingData.section1image1.image} />}

      <h2 className='LDM-heading'>{LongDistanceMovingData ? LongDistanceMovingData.section2heading1.content : 'No Text'}
        <i onClick={() => ShowTextModal(LongDistanceMovingData.section2heading1._id)} className="far fa-edit Edit-btn"></i>
      </h2>

      {LongDistanceMovingData && <FourCardSection
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        CardData={LongDistanceMovingData} />}

      {LongDistanceMovingData && <PlanSection
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        Heading={LongDistanceMovingData ? LongDistanceMovingData.section4heading1.content : 'No Text'}
        HeadingId={LongDistanceMovingData ? LongDistanceMovingData.section4heading1._id : 'No Text'}
        Para={LongDistanceMovingData ? LongDistanceMovingData.section4paragraph1.content : 'No Text'}
        ParaId={LongDistanceMovingData ? LongDistanceMovingData.section4paragraph1._id : 'No Text'}
        CardData={{
          Card1: {
            heading: LongDistanceMovingData.section5heading1.content,
            headingId: LongDistanceMovingData.section5heading1._id,
            para: LongDistanceMovingData.section5paragraph1.content,
            paraId: LongDistanceMovingData.section5paragraph1._id,
          },
          Card2: {
            heading: LongDistanceMovingData.section5heading2.content,
            headingId: LongDistanceMovingData.section5heading2._id,
            para: LongDistanceMovingData.section5paragraph2.content,
            paraId: LongDistanceMovingData.section5paragraph2._id,
          },
          Card3: {
            heading: LongDistanceMovingData.section5heading3.content,
            headingId: LongDistanceMovingData.section5heading3._id,
            para: LongDistanceMovingData.section5paragraph3.content,
            paraId: LongDistanceMovingData.section5paragraph3._id,
          },
          Card4: {
            heading: LongDistanceMovingData.section5heading4.content,
            headingId: LongDistanceMovingData.section5heading4._id,
            para: LongDistanceMovingData.section5paragraph4.content,
            paraId: LongDistanceMovingData.section5paragraph4._id,
          },
          Card5: {
            heading: LongDistanceMovingData.section5heading5.content,
            headingId: LongDistanceMovingData.section5heading5._id,
            para: LongDistanceMovingData.section5paragraph5.content,
            paraId: LongDistanceMovingData.section5paragraph5._id,
          },
          Card6: {
            heading: LongDistanceMovingData.section5heading6.content,
            headingId: LongDistanceMovingData.section5heading6._id,
            para: LongDistanceMovingData.section5paragraph6.content,
            paraId: LongDistanceMovingData.section5paragraph6._id,
          }
        }} />
      }

      {
        LongDistanceMovingData && <GetQuoteForm UpdateImage={UpdateImage} 
        imageID={LongDistanceMovingData.image._id} image={LongDistanceMovingData.image.image} />
      }

      {/* Update Text Modal */}
      <Modal width={400} style={{ top: '20%' }} title='Update Text' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
        <textarea onKeyPress={(e) => OnEnterPress(e)} value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' placeholder='Update Heading...' />
      </Modal>

      {/* Update Image Modal */}
      <Modal width={700} style={{ top: '5%' }} title='Update Image' visible={ImageModal} onOk={OnImageHandle} onCancel={handleCancel} okText="Update" >
        <DropzoneArea
          filesLimit={1}
          acceptedFiles={['image/*']}
          dropzoneText={"Update Product Images"}
          onChange={(files) => {
            console.log('Files:', files[0])
            setImageUpdate(files[0])
          }}
        />
      </Modal>


    </Layout>
  );
}

export default LocalDistanceMoving;
